// extracted by mini-css-extract-plugin
module.exports = {"root":"Row_root___53lF","normal":"Row_normal__5PtBH","reverse":"Row_reverse__3DP5v"};